import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertColor,
  Slide,
  SlideProps,
  Snackbar,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Button from '../../components/General/Button'
import { dateToDB, formatPipe } from '../../utils/utils'
import Empty from '../../components/Display/Empty'
import CheckAnimation from '../../assets/animations/check.json'
import { useForm } from 'react-hook-form'
import WakuLogo from '../../assets/images/waku-image.svg'
import LogoNevula from '../../assets/images/logo-nevula.svg'
import axios from 'axios'
import Select from '../../components/Inputs/Select'
import { IoIosArrowDown } from 'react-icons/io'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import { useHistory } from 'react-router-dom'
import LogoBNC from '../../assets/images/bnc-original.svg'
import Datepicker from '../../components/Inputs/Datepicker'
import InputRadio from '../../components/Inputs/InputRadio'
import { v4 as uuidv4 } from 'uuid'
import { connect } from 'react-redux'
import { State } from 'safe'
import { signIn } from '../../redux/actions/authentication'

const server = process.env.REACT_APP_SERVER_URL
const environment = process.env.REACT_APP_ENVIRONMENT

const Deudor = ({ signIn }) => {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined)

  const [messageInfo, setMessageInfo] = useState<{
    severity: AlertColor
    title: string
  } | null>(null)

  const [alreadyPaid, setAlreadyPaid] = useState<boolean>(false)

  const [pagoInformation, setPagoInformation] = useState<any>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const form = useForm()

  const [activeStep, setActiveStep] = useState<number>(0)

  const paymentOptions = [
    { value: 'pagoMovil', text: 'Pago Móvil' },
    { value: 'card', text: 'Tarjeta' },
  ]

  const steps = [
    'Ingresar correo electrónico',
    'Realizar pago',
    'Confirmación de pago',
  ]

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
  ]

  const banksOptions = [
    {
      value: '0102',
      text: 'Banco de Venezuela',
    },
    {
      value: '0191',
      text: 'Banco Nacional de Credito',
    },
    {
      value: '0108',
      text: 'Banco Provincial',
    },
    {
      value: '0114',
      text: 'Bancaribe',
    },
    {
      value: '0115',
      text: 'Banco Exterior',
    },
    {
      value: '0163',
      text: 'Banco del Tesoro',
    },
    {
      value: '0134',
      text: 'Banesco',
    },
    {
      value: '0138',
      text: 'Banco Plaza',
    },
    {
      value: '0174',
      text: 'Banplus',
    },
    {
      value: '0169',
      text: 'Mi Banco',
    },
    {
      value: '0157',
      text: 'DEL SUR BU',
    },
    {
      value: '0168',
      text: 'Bancrecer',
    },
    {
      value: '0171',
      text: 'Banco Activo',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0172',
      text: 'Bancamiga',
    },
    {
      value: '0105',
      text: 'Mercantil',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0177',
      text: 'BANFANB',
    },
    {
      value: '0175',
      text: 'Bicentenario',
    },
    {
      value: '0137',
      text: 'SOFITASA',
    },
    {
      value: '0166',
      text: 'Agricola',
    },
    {
      value: '0128',
      text: 'Caroni',
    },
    {
      value: '0156',
      text: '100% Banco',
    },
    {
      value: '0104',
      text: 'Venezolano de Credito',
    },
  ]

  const phoneTypes = [
    {
      value: '0412',
      text: '0412',
    },
    {
      value: '0414',
      text: '0414',
    },
    {
      value: '0416',
      text: '0416',
    },
    {
      value: '0424',
      text: '0424',
    },
    {
      value: '0426',
      text: '0426',
    },
  ]

  const bankMessages = [
    {
      value: '0102',
      message:
        '(VÍA PORTAL WEB) Se solicita desde la página web de Banco de Venezuela o SMS 2661 o 2662 + cedula',
    },
    {
      value: '0191',
      message:
        '(VÍA WEB) Pestaña Pagos/Pago Móvil ->Generador Clave C2P Claves a generar -',
    },
    {
      value: '0108',
      message:
        '(VÍA APP ANDROID) Dinero Rápido -> QuieroGenerar Clave de Compra -> Generar Clave',
    },
    {
      value: '0114',
      message: '(VÍA APP) Mi Pago Bancaribe -> Clave Mi Pago Comercio',
    },
    {
      value: '0115',
      message:
        '(VÍA SMS) Envíe al 278 el texto CLAVE V su número de cédula (o E si es extranjero).',
    },
    {
      value: '0163',
      message:
        '(VÍA APP) Debe ingresar a la aplicación “Tesoro Pago Móvil (P2P) y solicitar en esa APP la clave. (VÍA SMS) Envíe al 2383 el texto "Comercio" + V + su número de cédula + (una coordenada a elegir)',
    },
    {
      value: '0134',
      message:
        'Generar Claves Dinámicas a través del portal de Mis Solicitudes banesco o enviando un SMS al número 2846 de la siguiente forma: Coloca la palabra clave dinamica, el tipo de literal: V, E ó J, según sea el caso, y el número de cédula o RIF. Recuerda dejar un espacio entre cada dato. Ejemplo: clave dinamica V 00000000',
    },
    {
      value: '0138',
      message:
        '(VÍA APP) Tu DineroYa -> Generar Token (VÍA SMS) Envíe al 1470 el texto: CLAVE V su número de cédula. (o E si es extranjero) (VÍA WEB) Tu Plaza en Línea',
    },
    {
      value: '0174',
      message: '(VÍA APP) Pago Plus -> Clave C2P',
    },
    {
      value: '0169',
      message: '(VÍA SMS) Envíe al 22622 el texto: PAGAR',
    },
    {
      value: '0157',
      message: '(VÍA SMS) Envíe al 78910 el texto COBROD2',
    },
    {
      value: '0168',
      message: '(VÍA APP) Pag@Ya de Bancrecer. Ahí encuentra la clave C2P.',
    },
    {
      value: '0171',
      message:
        '(VÍA APP) Pago Activo. Ahí encuentra la clave C2P. (VÍA SMS) Envíe al 228486 el texto C2P+TIPO DE DOCUEMENTO+NUMERO DE DOCUMENTO',
    },
    {
      value: '0151',
      message: 'desde la aplicación Tesoro Pago Móvil (P2P).',
    },
    {
      value: '0172',
      message:
        '(Via APP) se obtiene al entrar a Bancamiga Suite y después a Pago Móvil.',
    },
    {
      value: '0105',
      message:
        '(Via APP) de Tpago en el botón Clave C2P o a través de un SMS al 24024 con la palabra ...',
    },
    {
      value: '0151',
      message: '(VÍA APP) Pago Móvil BFC. Ahí encuentra la clave C2P',
    },
    {
      value: '0177',
      message:
        '(VÍA SMS) Envíe al 326200 si es Movistar o Digitel o 78900 si es Movilnet, el texto SERVICIO C2P',
    },
    {
      value: '0175',
      message:
        'En el menú principal da clic a Pago Móvil, escoge la opción Código de Autorización - C2P, por último, selecciona Solicitud del Código de Autorización.',
    },
    {
      value: '0137',
      message:
        '(VÍA APP) Sofitasa Pago Móvil. Ahí encuentra la clave P2C. (VIA WEB) Sofinet personas',
    },
    {
      value: '0166',
      message: 'Banca Móvil o e-banca Personas generar Clave Dinámica.',
    },
    {
      value: '0128',
      message:
        '(VÍA APP) Web Móvil → Solicitud del Código de Autorización (VÍA SMS) Envíe al 100102 el texto: C2P + PAGO + (la clave de transacciones especiales de Pago Móvil) → Le enviarán la Clave C2P.',
    },
    {
      value: '0156',
      message:
        '( Via APP o web 100%Internet Personas y a través de la Web Móvil. Generar Clave Dinamica',
    },
    {
      value: '0104',
      message:
        '(VÍA APP) Venezolano de Crédito AppBvc -> Clave C2P (VÍA WEB) Venezolano Online',
    },
  ]

  const planesOptions = [
    { value: 'emprendedor', text: 'Emprendedor' },
    { value: 'pyme', text: 'PYME' },
    { value: 'corporativo', text: 'Corporativo' },
    { value: 'estudiantil', text: 'Estudiantil' },
  ]

  const periodOptions = [
    { value: 'MONTHLY', text: 'Mensual' },
    { value: 'ANNUAL', text: 'Anual' },
  ]

  const cardTypeOptions = [
    {
      value: 'visa',
      text: 'Visa',
    },
    {
      value: 'mastercard',
      text: 'Mastercard',
    },
    {
      value: 'debit',
      text: 'Débito Maestro',
    },
  ]

  const monthOptions = [
    { value: '01', text: '01' },
    { value: '02', text: '02' },
    { value: '03', text: '03' },
    { value: '04', text: '04' },
    { value: '05', text: '05' },
    { value: '06', text: '06' },
    { value: '07', text: '07' },
    { value: '08', text: '08' },
    { value: '09', text: '09' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
  ]

  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = new Date().getFullYear() + i
    return { value: year.toString(), text: year.toString() }
  })

  const [selectedAmount, setSelectedAmount] = useState(0)

  //   function TransitionDown(props: TransitionProps) {
  //     return <Slide {...props} direction="down" />
  //   }

  const [skipped, setSkipped] = React.useState(new Set<number>())

  const [userInfo, setUserInfo] = useState<IUserInfo | null>(null)

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    string | null
  >(null)

  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false)

  const [message, setMessage] = useState<string | null>(null)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [firstStepInfo, setFirstStepInfo] = useState<any | null>(null)

  const isStepSkipped = (step: number) => {
    return skipped.has(step)
  }

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />
  }

  const history = useHistory()

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const onSubmit = async (values) => {
    if (activeStep === 0) {
      try {
        setLoading(true)
        // let response = await axios.get<IUserInfo>(
        //   `${server}/debtor?email=${values?.email}`
        // )
        setFirstStepInfo(values)
        // const [response, bsResponse] = await Promise.all([
        //   axios.get<IUserInfo>(`${server}/debtor?email=${values?.email}`),
        //   axios.post(`${server}/nevula-payment/bs-price`, {
        //     plan: values?.userPlan,
        //     period: values?.period,
        //   }),
        // ])

        const bsResponse = await axios.post(
          `${server}/nevula-payment/bs-price`,
          {
            plan: values?.userPlan,
            period: values?.period,
          }
        )

        // setUserInfo(response?.data)
        setSelectedPaymentMethod(values?.paymentMethod)
        setLoading(false)
        setActiveStep((prevState) => prevState + 1)
        form.setValue('amount', `Bs. ${bsResponse?.data?.total}`)
        console.log('bsResponse?.data?.total', bsResponse?.data?.total)
        setSelectedAmount(bsResponse?.data?.total)
      } catch (err) {
        setTransition(() => TransitionDown)
        setMessageInfo({ severity: 'error', title: 'Correo no existente' })
      } finally {
        setLoading(false)
      }
    }

    if (activeStep === 1) {
      if (firstStepInfo?.paymentMethod === 'pagoMovil') {
        setLoading(true)


        const body = {
          period: firstStepInfo?.period,
          ref: values?.ref,
          amount: formatPipe(values?.amount, true, 2, -9999999999999999) + '',
          paymentDate: dateToDB(values?.paymentDate),
          plan: firstStepInfo?.userPlan,
          senderPhoneNumber: `58${values?.phoneCode.slice(1)}${values?.phoneNumber}`,
        }

        const bodyBNC = {
          ref: values?.ref,
          amount: +formatPipe(values?.amount, true, 2, -9999999999999999),
          paymentDate: dateToDB(values?.paymentDate),
          senderPhoneNumber: `58${values?.phoneCode.slice(1)}${values?.phoneNumber}`,
          bankCode: +values?.bank?.slice(1)
        }

        try {
          
          let resp = await axios.post(`${server}/nevula-payment/consult-bnc`, bodyBNC)

          if (!resp?.data?.validated) {
            setIsLoading(false)
            setMessageInfo({
              severity: 'error',
              title: `Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente`,
            })
          
            return
          }

          let currentDate = new Date()

          let day = currentDate.getDate().toString().padStart(2, '0')
          let month = (currentDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')
          let year = currentDate.getFullYear()

          let respSecond = await axios.post(`${server}/nevula-payment/validate-debtor`, {...body, paymentToken: resp?.data?.token, email: firstStepInfo?.email})

          await axios.post(`${server}/nevula-payment/update-cognito`, {cognitoUpdateToken: respSecond?.data?.cognitoUpdateToken})


          await signIn({email: firstStepInfo?.email, password: firstStepInfo?.password})


          let responseUserTenant = await axios.get(
            `${server}/user/tenant`
          )

          const {
            plan,
            subscriptionType,
            subscriptionEnd,
          } = responseUserTenant.data?.tenant

          let bodyEmail = {
            client: {name: responseUserTenant?.data?.tenant?.businessSocial, document: `${responseUserTenant?.data?.tenant?.document?.documentType}-${responseUserTenant?.data?.tenant?.document?.document}`, email: responseUserTenant?.data?.tenant?.email, address: responseUserTenant?.data?.tenant?.address?.address},
            payment: {reference: values?.ref, date: dateToDB(`${day}/${month}/${year}`), method: 'Pago Móvil', amount: values?.amount },
            planType: plan,
            subscriptionType: subscriptionType,
          }

          await axios.post(`${server}/nevula-payment/email`, bodyEmail)
          
          setTimeout(() => {
            history.push('/dashboard')
          }, 2000)

          setActiveStep(2)
        } catch (err : any) {

          if (err?.response?.data?.message === 'Usuario no encontrado con el email proporcionado') {
            setMessageInfo({
              severity: 'error',
              title: `Usuario no encontrado con el email proporcionado`,
            })
            return
          }

          setMessageInfo({
            severity: 'error',
            title: `No se pudo verificar el pago móvil`,
          })
        } finally {
          setLoading(false)
        }
      } else {
        try {
          setLoading(true)

          const paddedDocument = values?.document?.padStart(9, '0');
              values.document = paddedDocument;

              const body = {
                transactionIdentifier: uuidv4(),
                amount: formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                idCardType: values?.cardType === 'visa' ? 1 : values?.cardType === 'mastercard' ? 2 : 3,
                cardNumber: values?.cardNumber,
                dtExpiration: +`${values?.expiryMonth}${values?.expiryYear}`,
                cardHolderName: values?.cardHolder,
                accountType: values?.accountType === 'ahorro' ? 10 : 20,
                cvv: values?.cvc,
                cardPIN: +values?.cardPin,
                cardHolderID: values?.document,
                childClientID: "",
                branchID: "",
                operationId: 1,
              }

             
              const secondBody = {
                period: firstStepInfo?.period,
                plan: firstStepInfo?.userPlan,
                amount: formatPipe(values?.amount, true, 2, -9999999999999999) + '',
              }

            
              let resp = await axios.post(`${server}/nevula-payment/card-transaction`, body)

              console.log("LUIS RESP", resp)

              if (!resp?.data?.success) {
                setIsLoading(false)
                setMessageInfo({
                  severity: 'error',
                  title: `Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente`,
                })
                return
              }

              let currentDate = new Date()

              let day = currentDate.getDate().toString().padStart(2, '0')
              let month = (currentDate.getMonth() + 1)
                .toString()
                .padStart(2, '0')
              let year = currentDate.getFullYear()

              
              let respSecond = await axios.post(`${server}/nevula-payment/validate-debtor`, {...secondBody, paymentToken: resp?.data?.token, email: firstStepInfo?.email})

              await axios.post(`${server}/nevula-payment/update-cognito`, {cognitoUpdateToken: respSecond?.data?.cognitoUpdateToken})

              await signIn({email: firstStepInfo?.email, password: firstStepInfo?.password})

              let responseUserTenant = await axios.get(
                `${server}/user/tenant`
              )
              //El subscriptionend llega como toIsoString 2024-12-25T00:00:00.000Z
              const {
                plan,
                subscriptionType,
                subscriptionEnd,
              } = responseUserTenant.data?.tenant


              const amount = formatPipe(values?.amount, true, 2, -9999999999999999) + ''

              const newAmount = formatPipe(amount) + ''

              let bodyEmail = {
                client: {name: responseUserTenant?.data?.tenant?.businessSocial, document: `${responseUserTenant?.data?.tenant?.document?.documentType}-${responseUserTenant?.data?.tenant?.document?.document}`, email: responseUserTenant?.data?.tenant?.email, address: responseUserTenant?.data?.tenant?.address?.address},
                payment: {reference: resp?.data?.ref, date: dateToDB(`${day}/${month}/${year}`), method: 'POS virtual / Tarjeta de débito', amount: newAmount },
                planType: plan,
                subscriptionType: subscriptionType,
              }

              await axios.post(`${server}/nevula-payment/email`, bodyEmail)

              setTimeout(() => {
                history.push('/dashboard')
              }, 2000)
              
          setActiveStep(2)
        } catch (err) {
          console.log("err", err)
          setMessageInfo({
            severity: 'error',
            title: `Error al validar pago`,
          })
        } finally {
          setIsLoading(false)
        }
      }
    }
  }

  return (
    <div className="h-screen relative">
      <Snackbar
        TransitionComponent={transition}
        open={messageInfo !== null}
        onClose={() => setMessageInfo(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setMessageInfo(null)}
          severity={messageInfo?.severity || 'info'}
          sx={{ width: '100%' }}
        >
          {messageInfo?.title}
        </Alert>
      </Snackbar>

      <Snackbar
        TransitionComponent={transition}
        open={openSnackBar}
        autoHideDuration={30000}
        onClose={() => {
          setOpenSnackBar(false)
          setTimeout(() => {
            setMessage(null)
          }, 200)
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => {
            setOpenSnackBar(false)
          }}
          severity="info"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>

      <div className="w-full flex flex-nowrap justify-between py-10 px-14">
        <div className="w-52">
          <img src={LogoNevula} alt="zerux" />
        </div>

        <div>
          <Button
            type="outline"
            classes="rounded-3xl w-40"
            onClick={async () => {
              history.push('/ingresar')
            }}
          >
            {'Iniciar sesión'}
          </Button>
        </div>
      </div>

      <div className="px-8 py-10" style={{ height: '80vh' }}>
        {true && (
          <>
            <div className="flex flex-row justify-center">
              <div
                className="mt-8 rounded-md mb-20"
                style={{ border: '2px #e8e8e9 solid', width: 800 }}
              >
                <div
                  className="w-full rounded-md"
                  style={{ backgroundColor: '#0033A0', height: 36 }}
                ></div>

                <div className="p-7">
                  <Form form={form} onSubmit={(values) => {
                    console.log('values', values)
                    onSubmit({...values, amount: values?.amount || `Bs. ${formatPipe(selectedAmount + "")}`})
                  }} classes="gap-x-5">
                    <div className="col-span-12">
                      <Stepper
                        activeStep={activeStep}
                        orientation={
                          windowSize.innerWidth <= 600
                            ? 'vertical'
                            : 'horizontal'
                        }
                      >
                        {steps.map((label, index) => {
                          const stepProps: { completed?: boolean } = {}
                          if (isStepSkipped(index)) {
                            stepProps.completed = false
                          }

                          return (
                            <Step key={label} {...stepProps}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          )
                        })}
                      </Stepper>
                    </div>

                    {activeStep === 0 && (
                      <>
                        <div className="col-span-12 md:col-span-6 mt-5">
                          <FormItem
                            name="email"
                            rules={{
                              required: 'Es necesario el correo electrónico',
                            }}
                          >
                            <InputText label="Correo electrónico" />
                          </FormItem>
                        </div>

                        <div className="col-span-12 md:col-span-6 mt-5">
                          <FormItem
                            name="password"
                            rules={{
                              required: 'Es necesario la contraseña',
                            }}
                          >
                            <InputText label="Contraseña" password />
                          </FormItem>
                        </div>

                        <FormItem
                          name="paymentMethod"
                          classes="col-span-12 md:col-span-6 md:mt-5"
                          defaultValue={paymentOptions[0]}
                        >
                          <Select label="Pagar con" options={paymentOptions} />
                        </FormItem>

                        <FormItem
                          name="userPlan"
                          classes="col-span-12 md:col-span-6"
                          defaultValue={planesOptions[0]}
                        >
                          <Select label="Plan actual" options={planesOptions} />
                        </FormItem>

                        <FormItem
                          name="period"
                          classes="col-span-12 md:col-span-6"
                          defaultValue={periodOptions[0]}
                        >
                          <Select label="Periodo" options={periodOptions} />
                        </FormItem>

                        <div className="col-span-12 h-full flex flex-row mt-5 justify-center">
                          <div className="w-1/2 pr-1">
                            <Button
                              type="primary"
                              classes="w-full"
                              htmlType="submit"
                              loading={loading}
                              disabled={loading}
                            >
                              {'Continuar'}
                            </Button>
                          </div>
                        </div>
                      </>
                    )}

                    {activeStep === 1 && selectedPaymentMethod === 'pagoMovil' && (
                      <>
                        <div
                          className="col-span-12 mt-5"
                          style={{ color: '#102b6d', fontWeight: 500 }}
                        >
                          Pago Móvil
                        </div>

                        <Accordion className="col-span-12 mt-2 mb-5">
                          <AccordionSummary
                            expandIcon={<IoIosArrowDown />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography>Datos de pago móvil</Typography>
                          </AccordionSummary>

                          <AccordionDetails>
                            <Typography>Nombre: Waku Software</Typography>

                            <Typography>Banco: BNC</Typography>

                            <Typography>Telefono: 0412-9697598</Typography>

                            <Typography>RIF: J-413060540</Typography>
                          </AccordionDetails>
                        </Accordion>

                        {/* Banco emisor */}
                        <FormItem
                          name="bank"
                          classes="md:col-span-6 sm:col-span-12"
                          rules={{ required: 'Es necesario el banco emisor' }}
                          defaultValue={banksOptions[0]}
                        >
                          <Select label="Banco emisor" options={banksOptions} />
                        </FormItem>

                        {/* Monto */}
                        <FormItem
                          name="amount"
                          classes="md:col-span-6 sm:col-span-12"
                          rules={{
                            required: 'Es necesario el monto',
                          }}
                        >
                          <CurrencyInput
                            disabled={environment === 'prod'}
                            addDecimals={true}
                            mask="Bs. num"
                            label="Monto"
                            value={selectedAmount.toString()}
                          />
                        </FormItem>

                        {/* Número telefónico - Código */}
                        <FormItem
                          name="phoneCode"
                          classes="md:col-span-3 sm:col-span-12"
                          rules={{
                            required: 'Es necesario el código telefónico',
                          }}
                          defaultValue={{ value: '0416', text: '0416' }}
                        >
                          <Select
                            label="Código"
                            options={[
                              { value: '0412', text: '0412' },
                              { value: '0414', text: '0414' },
                              { value: '0416', text: '0416' },
                              { value: '0424', text: '0424' },
                              { value: '0426', text: '0426' },
                            ]}
                          />
                        </FormItem>

                        {/* Número telefónico - Número */}
                        <FormItem
                          name="phoneNumber"
                          classes="md:col-span-3 sm:col-span-12"
                          defaultValue={''}
                          rules={{
                            required: 'Es necesario el número telefónico',
                          }}
                        >
                          <InputText
                            label="Teléfono"
                            innerProps={{
                              type: 'tel',
                              placeholder: '1234567',
                            }}
                          />
                        </FormItem>

                        {/* Referencia */}
                        <FormItem
                          name="ref"
                          classes="md:col-span-6 sm:col-span-12"
                          rules={{
                            required: 'Es necesario el número de referencia',
                          }}
                        >
                          <InputText label="Referencia" />
                        </FormItem>

                        {/* Fecha de pago */}
                        <FormItem
                          name="paymentDate"
                          classes="md:col-span-6 sm:col-span-12"
                          rules={{
                            required: 'Es necesario la fecha de pago',
                          }}
                        >
                          <Datepicker label="Fecha de pago" />
                        </FormItem>

                        <div className="col-span-12 h-full flex flex-row justify-center mt-4">
                          <Button
                            type="outline"
                            classes="w-1/3 mr-3"
                            onClick={() => setActiveStep(0)}
                          >
                            Cancelar
                          </Button>

                          <Button
                            type="primary"
                            classes="w-1/3"
                            htmlType="submit"
                            disabled={isLoading}
                            loading={loading}
                          >
                            Continuar
                          </Button>
                        </div>

                        <div
                          style={{
                            height: 1,
                            width: '100%',
                            backgroundColor: '#CFCFCF',
                          }}
                          className="col-span-12 mt-3"
                        ></div>
                      </>
                    )}

                    {activeStep === 1 && selectedPaymentMethod === 'card' && (
                      <>
                         <div
          className="col-span-12 mt-5"
          style={{ color: '#102b6d', fontWeight: 500 }}
        >
          Tarjeta
        </div>

        {/* Tipo de cuenta - Radio buttons */}
        <div className="col-span-12">
          <FormItem
            name="accountType"
            rules={{ required: 'Es necesario seleccionar el tipo de cuenta' }}
            defaultValue="ahorro"
          >
            <InputRadio
              label="Tipo de cuenta"
              options={[
                { name: 'Ahorro', value: 'ahorro', selected: true },
                { name: 'Corriente', value: 'corriente', selected: false },
              ]}
            />
          </FormItem>
        </div>

        {/* Columna izquierda */}
        <div className="col-span-6">
          {/* Número de tarjeta */}
          <FormItem
            name="cardNumber"
            rules={{ required: 'Es necesario el número de tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Nro de tarjeta"
              innerProps={{
                type: 'text',
                placeholder: '1234 5678 9012 3456',
                maxLength: 19,
              }}
            />
          </FormItem>

          {/* Titular de la tarjeta */}
          <FormItem
            name="cardHolder"
            rules={{ required: 'Es necesario el titular de la tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Titular de la tarjeta"
              innerProps={{
                type: 'text',
                placeholder: 'Nombre completo',
              }}
            />
          </FormItem>

          {/* Monto */}
          <FormItem
            name="amount"
            rules={{
              required: 'Es necesario el monto',
            }}
          >
            <CurrencyInput
              disabled={environment === 'prod'}
              addDecimals={true}
              mask="Bs. num"
              label="Monto"
              value={selectedAmount.toString()}

            />
          </FormItem>

          <div className="col-span-12 flex flex-row">
            <FormItem
              name="documentType"
              rules={{ required: 'Es necesario un nombre' }}
              classes="w-[30%]"
              defaultValue={docs[0]}
            >
              <Select options={docs} label="Tipo" />{' '}
            </FormItem>

            {/* Documento */}
            <FormItem
              name="document"
              rules={{ required: 'Es necesario el documento' }}
              defaultValue=""
            >
              <InputText
                maxLength={9}
                label="Documento"
                innerProps={{
                  type: 'text',
                  placeholder: '12345678',
                }}
              />
            </FormItem>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="col-span-6">
          {/* CVC */}
          <FormItem
            name="cvc"
            rules={{ required: 'Es necesario el CVC' }}
            defaultValue=""
          >
            <InputText
              label="CVC"
              innerProps={{
                type: 'text',
                placeholder: '123',
                maxLength: 4,
              }}
            />
          </FormItem>

          {/* PIN de la tarjeta */}
          <FormItem
            name="cardPin"
            rules={{ required: 'Es necesario el PIN de la tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Pin de la tarjeta"
              innerProps={{
                type: 'password',
                placeholder: '••••',
              }}
            />
          </FormItem>

          {/* Mes y año */}
          <div className="flex gap-2">
            <FormItem
              name="expiryMonth"
              classes="flex-1"
              rules={{ required: 'Es necesario el mes' }}
              defaultValue={monthOptions[0]}
            >
              <Select label="Mes" options={monthOptions} />
            </FormItem>
            <FormItem
              name="expiryYear"
              classes="flex-1"
              rules={{ required: 'Es necesario el año' }}
              defaultValue={yearOptions[0]}
            >
              <Select label="Año" options={yearOptions} />
            </FormItem>
          </div>

          {/* Tipo de tarjeta */}
          <FormItem
            name="cardType"
            rules={{ required: 'Es necesario el tipo de tarjeta' }}
            defaultValue={cardTypeOptions[0]}
          >
            <Select label="Tipo de tarjeta" options={cardTypeOptions} />
          </FormItem>
        </div>

                        <div className="col-span-12 h-full flex flex-row justify-center mt-4">
                          <Button
                            type="outline"
                            classes="w-1/3 mr-3"
                            onClick={() => setActiveStep(0)}
                            loading={loading}
                          >
                            Cancelar
                          </Button>

                          <Button
                            type="primary"
                            classes="w-1/3"
                            htmlType="submit"
                            disabled={isLoading}
                            loading={loading}
                          >
                            Continuar
                          </Button>
                        </div>

                        <div
                          style={{
                            height: 1,
                            width: '100%',
                            backgroundColor: '#CFCFCF',
                          }}
                          className="col-span-12 mt-5"
                        ></div>
                      </>
                    )}

                    {activeStep === 2 && (
                      <div className="col-span-12 flex flex-col justify-center items-center mt-10">
                        <h1>Este pago ha sido realizado satisfactoriamente</h1>
                        <Empty
                          isFromLoading={true}
                          animationProps={{
                            height: 200,
                            width: 200,
                            animation: CheckAnimation,
                          }}
                          lottieProps={{
                            style: { position: 'relative', zIndex: 1 },
                          }}
                          loop={false}
                        ></Empty>
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div
        className="h-10 w-full fixed bottom-0 flex justify-end"
        style={{ backgroundColor: '#0033A0' }}
      >
        <img src={WakuLogo} alt="waku" />
      </div>
    </div>
  )
}

interface IUserInfo {
  cognitoSubs: string[]
  subscriptionEnd: string
}

type TransitionProps = Omit<SlideProps, 'direction'>

const mapState = ({ auth }: State) => ({ auth })

const connector = connect(mapState, { signIn })

export default connector(Deudor)

